import { defineStore } from "pinia"
import { ref, watch } from "vue"

export enum ParcelHintStatus {
	Inactive = "inactive",
	Requested = "requested",
	Shown = "shown",
	NotFound = "not-found",
}

export const useUIStore = defineStore("ui", () => {
	const isDrawerOpen = ref(true)
	const isSearchOpen = ref(false)

	const isSidenavLocked = ref(sessionStorage.getItem("sidenav-locked") === "true")

	watch(isSidenavLocked, value => {
		sessionStorage.setItem("sidenav-locked", String(value))
	})

	const toggleDrawer = () => {
		isDrawerOpen.value = !isDrawerOpen.value
	}

	const openDrawer = () => {
		isDrawerOpen.value = true
	}

	const closeDrawer = () => {
		isDrawerOpen.value = false
	}

	const toggleSidenavLocked = () => {
		isSidenavLocked.value = !isSidenavLocked.value
	}

	const isAppTourActive = ref(false)

	const startAppTour = () => {
		isAppTourActive.value = true
	}

	const stopAppTour = () => {
		isAppTourActive.value = false
	}

	const parcelHintStatus = ref(ParcelHintStatus.Inactive)

	const requestParcelHint = () => {
		parcelHintStatus.value = ParcelHintStatus.Requested
	}

	const clearParcelHint = () => {
		parcelHintStatus.value = ParcelHintStatus.Inactive
	}

	return {
		isDrawerOpen,
		isSearchOpen,
		isSidenavLocked,
		isAppTourActive,
		parcelHintStatus,
		toggleDrawer,
		openDrawer,
		closeDrawer,
		toggleSidenavLocked,
		startAppTour,
		stopAppTour,
		requestParcelHint,
		clearParcelHint,
	}
})
